package com.ilussobsa

import com.lightningkite.kiteui.views.*
import com.lightningkite.reactive.context.onRemove
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.w3c.dom.HTMLScriptElement
import kotlin.js.Promise
import kotlin.js.json
import kotlin.time.Duration.Companion.seconds


private var auctioneerViewInstanceCounter = 0
actual class AuctioneerView actual constructor(context: RContext) : RView(context) {
    var unityInstance:dynamic = null
    private val instanceNumber = auctioneerViewInstanceCounter++
    private val actionQueue = FixedSizeQueue<AnimationAction>(10)
    init {
        native.tag = "div"
        native.classes.add("auctioneer-view")

        native.appendChild(FutureElement().apply{
            tag = "div"
            classes.add("unity-desktop")
            id = "unity-container"
            appendChild( FutureElement().apply {
                tag = "canvas"
                id ="unity-canvas-$instanceNumber"
                attributes.widthInt = 500
                attributes.heightInt = 450
            })
        })
        native.onElement {
            println("native.onElement")
            this@AuctioneerView.launch {
                println("native.onElement.launch")
                val buildUrl  = "/auctioneer-animation"
                val loaderUrl = "$buildUrl/auctioneer.loader.js"
                val config =  json(
                    "dataUrl" to "$buildUrl/auctioneer.data",
                    "frameworkUrl" to "$buildUrl/auctioneer.framework.js",
                    "codeUrl" to "$buildUrl/auctioneer.wasm",
                    "streamingAssetsUrl" to "StreamingAssets",
                    "companyName" to "KevuruGames",
                    "productName" to "IlussoClient",
                    "productVersion" to "0.08",
                    "devicePixelRatio" to "1.0",
                )
                val script = document.createElement("script") as HTMLScriptElement
                script.src = loaderUrl
                script.onload = {
                    println("script.onload")
                    // Launch inside onload to be absolutely certain that this coroutine is cancelled when the view is
                    // shutdown
                    this@AuctioneerView.launch {
                        println("script.onload.launch")

                        // Delay to be sure that this view is actually needed
                        // After navigation, we observed behavior where a page would undergo layout twice and the views
                        // from one of the layouts would all shutdown immediately after. In such a case, we do not want
                        // to trigger a runaway createUnityInstance() call
                        delay(2.seconds)
                        println("AuctioneerView instance $instanceNumber creating Unity instance")

                        val instancePromise = (window.asDynamic()).createUnityInstance(document.querySelector("#unity-canvas-$instanceNumber"), config) { progress: Float ->
                            console.log("$instanceNumber\t$progress")
                            Unit
                        } as Promise<dynamic>

                        instancePromise.then {instance:dynamic->
                            println("Unity instance promise has fulfilled; unity is ready")
                            unityInstance = instance
                        }
                    }
                    Unit
                }
                it.append(script)
            }
        }
        onRemove {
            println("AuctioneerView instance $instanceNumber is shutting down")
            if (unityInstance != null) {
                println("Shutting down unity instance associated with AuctioneerView instance $instanceNumber")
                val unityInstanceToShutdown = unityInstance
                unityInstance = null
                unityInstanceToShutdown.Quit()
            }
        }
        launch {
            while (true) {
                actionQueue.poll()?.let { value ->
                    if(unityInstance!= null && value != AnimationAction.IDLE) {
                        println("Sending $value to unity instance")
                        unityInstance.SendMessage("HooksCatcher",value.action)
                    } else {
                        println("Tried to send $value to unity instance; unityInstance=$unityInstance")
                    }
                }
                delay(500)
            }
        }
    }

    actual var animationAction: AnimationAction
        get() = TODO("Not yet implemented")
        set(value) {
            actionQueue.offer(value)
        }
}

class FixedSizeQueue<T>(private val capacity: Int) {
    private val queue = ArrayDeque<T>()

    fun offer(element: T) {
        if (queue.size == capacity) {
            queue.removeFirst() // Remove the oldest element
        }
        queue.addLast(element) // Add the new element
    }

    fun poll(): T? = queue.removeFirstOrNull()

    fun peek(): T? = queue.firstOrNull()

    fun toList(): List<T> = queue.toList()

    fun size(): Int = queue.size

    fun isEmpty(): Boolean = queue.isEmpty()
}
